class GridViewSwitcher extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll('.grid-view-button');
    this.productGrid = document.querySelector('#results-grid');

    if (!this.productGrid) return;

    // Vérifier si on doit forcer la vue liste (moins de 3 résultats)
    const resultsCount = parseInt(this.productGrid.dataset.resultsCount || '999', 10);
    const forceListView = resultsCount > 0 && resultsCount < 3;

    if (forceListView) {
      // Forcer la vue liste sans sauvegarder dans localStorage
      this.currentView = '1';
      this.applyView(this.currentView);
    } else {
      // Récupérer la vue sauvegardée ou utiliser 4 colonnes par défaut
      this.currentView = localStorage.getItem('gridView') || '4';
      this.applyView(this.currentView);
    }

    this.buttons.forEach((button) => {
      button.addEventListener('click', this.handleClick.bind(this));
    });
  }

  handleClick(event) {
    const button = event.currentTarget;
    const columns = button.dataset.columns;

    this.currentView = columns;
    this.applyView(columns);

    // Sauvegarder la préférence
    localStorage.setItem('gridView', columns);
  }

  applyView(columns) {
    // Refresh grid reference if needed
    if (!this.productGrid || !document.contains(this.productGrid)) {
      this.productGrid = document.querySelector('#results-grid');
    }

    if (!this.productGrid) return;

    // Retirer toutes les classes de colonnes
    this.productGrid.classList.remove('grid--1-col', 'grid--2-col', 'grid--4-col', 'grid--6-col');

    // Ajouter la nouvelle classe
    this.productGrid.classList.add(`grid--${columns}-col`);

    // Mettre à jour l'état actif des boutons
    this.buttons.forEach((btn) => {
      if (btn.dataset.columns === columns) {
        btn.classList.add('active');
        btn.setAttribute('aria-pressed', 'true');
      } else {
        btn.classList.remove('active');
        btn.setAttribute('aria-pressed', 'false');
      }
    });
  }

  // Méthode pour rafraîchir la référence à la grille après un update AJAX
  refresh() {
    this.productGrid = document.querySelector('#results-grid');
    if (this.productGrid && this.currentView) {
      this.applyView(this.currentView);
    }
  }
}

customElements.define('grid-view-switcher', GridViewSwitcher);
